// 学习管理模块配置
export const studyConfig = {
  // 模块基本信息
  name: '学习管理',
  description: '计划、知识、技能',
  icon: 'BookOutlined',
  bgColor: '#F8C471',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    studies: '/study',
    create: '/study',
    update: '/study',
    delete: '/study',
    progress: '/study/progress',
    addProgress: '/study/progress',
    deleteProgress: '/study/progress'
  },
  
  // 学习状态
  studyStatus: [
    { value: 'not_started', label: '未开始', color: '#FF4D4F', description: '计划中，还未开始学习' },
    { value: 'in_progress', label: '进行中', color: '#1890FF', description: '正在学习过程中' },
    { value: 'completed', label: '已完成', color: '#52C41A', description: '学习目标已完成' },
    { value: 'paused', label: '已暂停', color: '#FAAD14', description: '暂时停止学习' }
  ],
  
  // 学习类型
  studyTypes: [
    '技能学习', '知识学习', '考试备考', '语言学习', '技术培训', '职业发展', '兴趣爱好', '其他'
  ],
  
  // 学习方法
  studyMethods: [
    '阅读学习', '视频学习', '实践练习', '讨论交流', '在线课程', '面授培训', '自学研究', '其他'
  ],
  
  // 学习管理四大关键
  studyManagementKeys: {
    title: '学习管理四大关键',
    sections: [
      {
        title: '① 目标管理 —— 知道"学什么，为了什么"',
        subtitle: '明确目标、分解目标、SMART原则',
        items: [
          '明确目标：比如"期末考试数学 80+"，"两个月掌握Python基础"',
          '分解目标：大目标拆成小目标，例如"每天刷 10 道题"',
          'SMART 原则：具体（Specific）、可衡量（Measurable）、能实现（Achievable）、相关性（Relevant）、有时限（Time-bound）'
        ]
      },
      {
        title: '② 时间管理 —— 会安排，才高效',
        subtitle: '番茄工作法、优先级管理、规律学习',
        items: [
          '番茄工作法：25 分钟专注学习 + 5 分钟休息，防止疲劳',
          '优先级管理：先做最重要/最难的事（艾森豪威尔矩阵）',
          '规律学习时间：每天固定学习时段，养成习惯'
        ]
      },
      {
        title: '③ 方法管理 —— 学习要讲策略',
        subtitle: '主动学习、费曼学习法、多元复习',
        items: [
          '主动学习：多问为什么，而不是死记硬背',
          '费曼学习法：把学到的东西"讲给别人听"，发现盲点',
          '多元复习：看书 → 做题 → 归纳总结 → 自测，形成闭环',
          '利用工具：思维导图、Anki 记忆卡、Notion 笔记等'
        ]
      },
      {
        title: '④ 反馈与优化 —— 学习是个迭代过程',
        subtitle: '定期复盘、检测成果、调整计划',
        items: [
          '定期复盘：每周回顾自己学了什么、哪里浪费了时间',
          '检测成果：通过模拟题、测验来检验，而不是自我感觉良好',
          '调整计划：如果某种学习方法效果不好，要及时更换'
        ]
      }
    ],
    summary: '🌟 一句话口诀：定目标 → 做计划 → 勤复习 → 常总结 → 勇改进'
  },
  
  // 学习技巧建议
  studyTips: {
    title: '高效学习技巧',
    sections: [
      {
        title: '专注力管理',
        items: [
          '使用番茄工作法：25分钟专注 + 5分钟休息',
          '创造无干扰环境：关闭手机通知，选择安静场所',
          '设定明确的学习目标：每次学习前明确要完成什么',
          '使用白噪音：如雨声、咖啡厅背景音，帮助集中注意力'
        ]
      },
      {
        title: '记忆技巧',
        items: [
          '间隔重复：使用Anki等工具进行科学复习',
          '联想记忆：将新知识与已有知识建立联系',
          '多感官学习：听、说、读、写、做相结合',
          '费曼技巧：尝试向他人解释所学内容'
        ]
      },
      {
        title: '时间规划',
        items: [
          '制定学习计划：日计划、周计划、月计划',
          '优先级排序：重要且紧急 > 重要不紧急 > 紧急不重要 > 不重要不紧急',
          '利用碎片时间：通勤、排队时复习知识点',
          '建立学习习惯：固定时间、固定地点学习'
        ]
      },
      {
        title: '知识管理',
        items: [
          '建立知识体系：使用思维导图整理知识点',
          '定期复习：艾宾浩斯遗忘曲线复习计划',
          '实践应用：学以致用，理论联系实际',
          '总结归纳：定期总结学习心得和方法'
        ]
      }
    ]
  },
  
  // 学习工具推荐
  studyTools: {
    title: '学习工具推荐',
    sections: [
      {
        title: '笔记工具',
        items: [
          'Notion：全能型笔记和知识管理工具',
          'OneNote：微软官方笔记工具，支持手写',
          '印象笔记：简单易用的笔记工具',
          '语雀：阿里系知识管理平台'
        ]
      },
      {
        title: '记忆工具',
        items: [
          'Anki：科学间隔重复记忆软件',
          'Quizlet：在线闪卡学习平台',
          'Memrise：语言学习记忆工具',
          'SuperMemo：高级记忆算法工具'
        ]
      },
      {
        title: '时间管理',
        items: [
          'Forest：专注时间管理应用',
          '番茄钟：经典的番茄工作法工具',
          'Toggl：时间追踪和分析工具',
          'RescueTime：自动时间追踪工具'
        ]
      },
      {
        title: '学习平台',
        items: [
          'Coursera：国际知名在线课程平台',
          'edX：哈佛、MIT等名校课程',
          '中国大学MOOC：国内优质课程平台',
          'B站：丰富的学习视频资源'
        ]
      }
    ]
  },
  
  // 学习进度记录模板
  progressTemplates: [
    {
      title: '学习新内容',
      content: '今天学习了{content}，掌握了{keyPoints}，感觉{feeling}。'
    },
    {
      title: '复习巩固',
      content: '复习了{content}，通过{method}加深了理解，掌握程度{level}。'
    },
    {
      title: '实践练习',
      content: '完成了{exercise}练习，遇到{problems}，解决方法{solution}。'
    },
    {
      title: '测试检验',
      content: '进行了{test}测试，成绩{score}，发现{weaknesses}需要加强。'
    },
    {
      title: '总结反思',
      content: '本周学习{summary}，收获{gains}，下周计划{plan}。'
    }
  ],
  
  // 学习目标模板
  goalTemplates: [
    {
      title: '技能掌握',
      content: '在{timeframe}内掌握{skill}，达到{level}水平，能够{ability}。'
    },
    {
      title: '考试备考',
      content: '为{exam}做准备，目标分数{score}，重点复习{topics}。'
    },
    {
      title: '知识学习',
      content: '系统学习{subject}，理解{concepts}，应用{applications}。'
    },
    {
      title: '项目实践',
      content: '完成{project}项目，运用{technologies}，实现{features}。'
    }
  ],
  
  // 学习计划建议
  studyPlanAdvice: {
    title: '制定学习计划建议',
    sections: [
      {
        title: '目标设定',
        items: [
          '明确学习目标：具体、可衡量、可实现',
          '分解大目标：将长期目标分解为短期目标',
          '设定时间节点：为每个阶段设定完成时间',
          '考虑现实因素：结合工作、生活安排学习时间'
        ]
      },
      {
        title: '计划执行',
        items: [
          '制定详细计划：日计划、周计划、月计划',
          '预留缓冲时间：为意外情况预留时间',
          '定期检查进度：每周回顾计划执行情况',
          '灵活调整计划：根据实际情况调整学习安排'
        ]
      },
      {
        title: '效果评估',
        items: [
          '设定评估标准：如何衡量学习效果',
          '定期自我检测：通过测试检验学习成果',
          '收集反馈信息：从他人或实践中获得反馈',
          '持续改进优化：根据评估结果调整学习方法'
        ]
      }
    ]
  }
};
